<template lang="pug">
.module-outlet
  template(v-if="module == undefined")
    template(v-for="(mod, modname) in Store.modules", v-if="mod.outlet[type]")
      template(v-if="Array.isArray(mod.outlet[type])")
        component(v-for="o in mod.outlet[type]", :key="Id(o)", :is="o", :frameStore="currentFrame.modules[modname]", :module="mod", :frame="currentFrame")
      template(v-else)
        component(:is="mod.outlet[type]", :frameStore="currentFrame.modules[modname]", :module="mod", :frame="currentFrame")
  template(v-else)
    template(v-if="Array.isArray(Store.modules[module].outlet[type])")
      component(v-for="o in Store.modules[module].outlet[type]", :key="Id(o)", :is="o", :frameStore="currentFrame.modules[module]", :module="Store.modules[module]", :frame="currentFrame")
    template(v-else)
      component(:is="Store.modules[module].outlet[type]", :frameStore="currentFrame.modules[module]", :module="Store.modules[module]", :frame="currentFrame")
</template>


<script lang="ts">
import Vue from 'vue'
import { Frame, store } from '@/store';
export default Vue.extend({
  props: {
    type: { required: true, type: String },
    module: { type: String },
    frame: {},
  },
  computed: {
    currentFrame(): Frame {
      return (this.frame as Frame) || store.currentFrame
    },
  },
})
</script>


<style lang="scss" scoped>
.module-outlet {
  display: inline;
}
</style>